<template>
    <div>
      <div v-if="isShowButton" class="btn_area flr">
        <a href="javascript:void(0);" v-if="options.general.type.isShowSearch" class="button white" @click="gridSearch"><span>조회</span></a>
        <a href="javascript:void(0);" v-if="options.general.type.isUpdate && !options.general.type.isHideAdd" class="button white" @click="addRow"><span>행추가</span></a>
        <a href="javascript:void(0);" v-if="options.general.type.isUpdate && !options.general.type.isHideDel" class="button white" @click="delRows"><span>행삭제</span></a>
        <a href="javascript:void(0);" v-if="options.general.type.isUpdate && !options.general.type.isHideReset" class="button white" @click="cancelDelRows"><span>행삭제취소</span></a>
        <a href="javascript:void(0);" v-if="options.general.type.isUpdate && !options.general.type.isHideUpdate" class="button white" @click="updateRows"><span>저장</span></a>
        <buttonExcel v-if="options.general.excel && options.general.excel.url != null" :url="options.general.excel.url" :fileName="options.general.excel.fileName" />
      </div>
      <div></div>
    </div>
</template>

<script>
import Grid from '@/modules/grid'   
import ButtonExcel from '@/components/ButtonExcel'

// grid option default
const options_d = {
  general : {
    id  : 'grid',
    search : null,
    update : null,
    excel : {
      url : null,
      fileName : null
    }, 
    type : {
      isDataShow : true,
      isUpdate : false,
      isHideAdd : false,
      isHideDel : false,
      isHideCancelDel : false,
      isHideReset : false,
      isHideUpdate : false
    },
    PageInfo : {
      current : 1,
      perPage : 10                
    },
    params : {}
  },
  grid_options : {
    rowInlineEdit: false,
    leaveDeleted: true,
    fullCompareForEditedState: true,
    autoColumnIndex: true,
    preventScrollPropagation: true,
    autoResize: true,
    cellSelectable: true,
    enableHeaderSelect: true, 
    //scrollbarPreview: { enabled : true },
    cellSelectableOption: { useHomeEndKey : true },
    enableNewDefaultContextMenu: true,
    enableNewContextMenu: true,
    newContextMenuUseOrder : ['freezePanes', 'freezePanesRow', 'freezePanesHeader', 'freezeCancel', 'enlarge', 'enlargeExit'],
	  defaultColumnMapping: {
      resizing: true,
      headerDragDrop: true,
      allowPaste : false
    },    
    rowInlineEditOption : {
			endEditByEnter : true
		},
	  //message: {
		//  nodata: '조회된 데이터가 없습니다.'
	  //},    
    progressStyleclass: '', 
    progressText: '로딩 중...',
    pager: true,
    paging: {
      pagerTotal: true,
      pagerSelect: [10,20,30]
    },
    rowSelectOption: {
		  //clickSelect: true
	  }
  }
}

export default {
  name: 'grid',
  components: { ButtonExcel },
  props: {
    options: {
      type: Object,
      default: {}
    }
  },
  mounted: function () {
    _.mergeWith(this.options, options_d, function (objValue, srcValue) {
      if(typeof objValue !== 'object') {
        if (objValue === undefined || objValue === null || objValue === '') {
          return srcValue;
        } else {
          return objValue;
        }
      }
    });

    if ( this.options.general.type.isUpdate ) {
      this.options.grid_options.rowInlineEdit = true;
    }

    var $el = $(this.$el);
    var grid_div = $el.find('div:last');
    grid_div.attr('id', this.options.general.id);
    grid_div.alopexGrid(this.options.grid_options);    

    // 
    this.$nextTick(function() {
      // update 기능 사용 처리
      if ( this.options.general.type.isUpdate ) {
        // validation 활성화
        Grid.setEditInvalid(this.options);

        // 행추가 시 배경색 표시
        //Grid.setDataAddColor(this.options);
      } 

      // 페이징 사용 처리
      if ( this.options.grid_options.pager == true ) {
        Grid.setPagingEvent(this.options);
      }

      // 로딩 시 조회 사용 처리
      if ( this.options.general.type.isDataShow == true ) {
        Grid.searchData(this.options);
      }

    });
  },
  computed: {
    // 버튼 영역 표시 여부
    isShowButton () {
      var result = false;

      if ( this.options.general.type.isShowSearch
            || ( this.options.general.type.isUpdate 
                && ( !this.options.general.type.isHideAdd
                      || !this.options.general.type.isHideDel
                      || !this.options.general.type.isHideReset
                      || !this.options.general.type.isHideUpdate ) ) 
            || (this.options.general.excel && this.options.general.excel.url != null)  ) {
        result = true;
      }

      return result
    }
  },  
  methods : {
      gridSearch () {
        Grid.searchData(this.options);
      },    
      addRow () {
        Grid.addRow(this.options);
      },
      delRows () {
        Grid.delRows(this.options);
      },
      cancelDelRows () {
        Grid.cancelDelRows(this.options);
      },
      resetRows () {
        Grid.resetRows(this.options);
      },
      updateRows () {
        Grid.updateRows(this.options);
      }
  }   
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Grid.vue